<script lang="ts" setup>
defineProps<{
    progress: boolean;
    healthy: boolean;
}>();

function reload() {
    window.location.reload();
}
</script>
<template>
    <div class="fixed w-screen h-screen flex flex-1 z-40 justify-center">
        <div class="flex flex-1 relative justify-center items-center">
            <div
                class="text-center relative flex flex-col"
                style="bottom: 80px; --surface-200: #aaa"
            >
                <div class="text-2xl font-bold">SHAPTH</div>
            </div>
            <template v-if="healthy">
                <ProgressSpinner v-if="progress" class="absolute" />
                <div class="absolute">
                    <div :class="progress ? 'loader' : 'static'" />
                </div>
                <div class="absolute">
                    <div class="shapth-logo" />
                </div>
            </template>
            <div v-else class="absolute text-center">
                <div class="text-xl pt-2">{{ $t('ux.errors.unexpected') }}</div>
                <div class="text-xl">{{ $t('ux.errors.unexpected_hint') }}</div>
                <div>
                    <Button
                        class="mt-4"
                        :label="$t('ux.labels.reload_page')"
                        @click="reload"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.shapth-logo {
    width: 60px;
    aspect-ratio: 1;
    border-radius: 50%;
    background-image: url('@/assets/shapth-logo.svg');
    opacity: 0.3;
}
.loader {
    --r1: 154%;
    --r2: 68.5%;
    width: 60px;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(var(--r1) var(--r2) at top, #0000 79.5%, #269af2 80%),
        radial-gradient(
            var(--r1) var(--r2) at bottom,
            #269af2 79.5%,
            #0000 80%
        ),
        radial-gradient(var(--r1) var(--r2) at top, #0000 79.5%, #269af2 80%),
        #ccc;
    background-size: 50.5% 220%;
    background-position:
        -100% 0%,
        0% 0%,
        100% 0%;
    background-repeat: no-repeat;
    animation: l9 2s infinite linear;
}
@keyframes l9 {
    33% {
        background-position:
            0% 33%,
            100% 33%,
            200% 33%;
    }
    66% {
        background-position:
            -100% 66%,
            0% 66%,
            100% 66%;
    }
    100% {
        background-position:
            0% 100%,
            100% 100%,
            200% 100%;
    }
}
.static {
    --r1: 154%;
    --r2: 68.5%;
    width: 60px;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(var(--r1) var(--r2) at top, #0000 79.5%, #269af2 80%),
        radial-gradient(
            var(--r1) var(--r2) at bottom,
            #269af2 79.5%,
            #0000 80%
        ),
        radial-gradient(var(--r1) var(--r2) at top, #0000 79.5%, #269af2 80%),
        #ccc;
    background-size: 50.5% 220%;
    background-position:
        -100% 0%,
        0% 0%,
        100% 0%;
    background-repeat: no-repeat;
}
</style>
